import { useMutation, useQueryClient } from '@tanstack/react-query';

import { uploadDocument } from '../services/api/documents';

type UploadPayload = {
  file: File;
  description?: string;
};

export const useDocumentUpload = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ file, description }: UploadPayload) => uploadDocument(file, description),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['documents'] });
    },
  });
};
